var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lc-form-button-bar",style:(_vm.componentStyle)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }